import React from 'react';
import { connect } from 'react-redux';
import numeral from 'numeral';
import { Bar, HorizontalBar } from 'react-chartjs-2';
import {chartOptions, chartData} from '../chart/config';
import { Collapse, Button } from 'antd';
import branding from '../data/branding';
import {data_items} from '../data/csv';
import CsvDownload from './CsvDownload';
import { startSetDetailView } from '../actions/globalState';
import ChartRenderProp from './ChartRenderProp';
import {dataTable, getPlurals} from '../utils/utils';

export class Statistic extends React.Component {

  onClick = () => {
    const detailView = true;
    this.props.startSetDetailView(detailView);
  }

  render() {

    let content, heading, sidebarData =  this.props.data.sidebarData, csv, button, containerClassName;
    
      if (sidebarData.length === 0) {
        content = <span>No Item</span>
      } else if  (sidebarData.length === 1) {
        button = <div className="button-container">
                  <Button type="primary" size="large" onClick={() => this.onClick()} className="full-width margin-bottom-xs-size"> View all data for {this.props.data.geo_name} </Button>
                  </div>
        heading = <h2>{this.props.data.geo_name} - {this.props.data.geo_type} </h2>
        content = <p>{sidebarData[0].population}: {numeral(sidebarData[0].total).format('0,0')} </p> 
        csv = ''
        containerClassName = 'heading-container'
      } else {
        //console.log('this.props.data.mapTotal.population_value', this.props.data.mapTotal.population_value)
        const tableName= `${branding}_${this.props.data.geo_name}_${this.props.data.category}`
        heading = <h2> {this.props.data.geo_name}</h2>

        content = <ChartRenderProp 
        tableName={tableName}
        header = { () => ( 
          <div>Top 10 {getPlurals(this.props.data.geo_type)}</div>
         )}
        render = { (setRef) => (
          <HorizontalBar download={true} redraw={true} 
          data={chartData(sidebarData.slice(0, data_items), 'geo_name', this.props.data.mapTotal.population_value, 'population')} 
          width={400}
          height={300} 
          options={chartOptions} 
          ref= {setRef}
          ></HorizontalBar>
        )} />
                    
        csv = <CsvDownload data={sidebarData}  tableName={tableName} />
        containerClassName='heading-container multiple'
      }

    return (
      <div className="statistic">
        <div className={containerClassName}>
          <div className="heading-container__item full-width">
            {button}
            {heading}
            {this.props.data.data_table !== undefined && <h3> {this.props.data.data_table.display_name}:  {this.props.data.category}</h3>}
          </div>
          <div className="heading-container__csv">
            {csv}
          </div>
        </div>
        {content}
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    data: state.globalState
  };
};
const mapDispatchToProps = (dispatch) => ({
  startSetDetailView: (value) => dispatch(startSetDetailView(value))
});

export default connect(mapStateToProps, mapDispatchToProps)(Statistic);



// WEBPACK FOOTER //
// ./src/components/Statistic.js